import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class Pagination extends Component{
//    constructor(props){
//        super(props)
//    }
    handlePreviousPage(e) {
        let previous_page = this.props.currentPage;
        if(previous_page > 1){
            previous_page = previous_page - 1
            if(window.location.pathname.includes('/view_scenario_catalogue') === true){
                const queryValue = this.props.property.match.params.queryValue !== undefined ? this.props.property.match.params.queryValue : null
                this.props.getApiInfo(previous_page, queryValue).then((response) => {
                    if(response){
                        this.props.dispatch(this.props.action(response))
                    } else{
                        this.props.dispatch(this.props.action({data: [], pages: [], currentPage: 0}))
                    }
                })
            }else{
                let dataToSend={
                    "scenario_group_prefix_name": this.props.filterValue
                }
                console.log(dataToSend)
                this.props.getApiInfo(previous_page,dataToSend).then((response) => {
                    if(response){
                        this.props.dispatch(this.props.action(response))
                    } else{
                        this.props.dispatch(this.props.action({data: [], pages: [], currentPage: 0}))
                    }
                })
            }
        }
    }
    handleForwardPage(e){
        let next_page = this.props.currentPage;
        let lastPage = this.props.pages.pop()
        if(next_page < lastPage){
            next_page = next_page + 1
            if(window.location.pathname.includes('/view_scenario_catalogue') === true){
            const queryValue = this.props.property.match.params.queryValue !== undefined ? this.props.property.match.params.queryValue : null
            this.props.getApiInfo(next_page, queryValue).then((response) => {
                if(response){
                    this.props.dispatch(this.props.action(response))
                } else{
                    this.props.dispatch(this.props.action({data: [], pages: [], currentPage: 0}))
                }
            })
            }else{
                let dataToSend={
                    "scenario_group_prefix_name": this.props.filterValue
                }
                console.log(dataToSend)
                this.props.getApiInfo(next_page,dataToSend).then((response) => {
                    if(response){
                        this.props.dispatch(this.props.action(response))
                    } else{
                        this.props.dispatch(this.props.action({data: [], pages: [], currentPage: 0}))
                    }
                })
            }
        }
    }
    handleData(e) {
        const page = e.target.id;
        if(window.location.pathname.includes('/view_scenario_catalogue') === true){
            const queryValue = this.props.property.match.params.queryValue !== undefined ? this.props.property.match.params.queryValue : null
            this.props.getApiInfo(page, queryValue).then((response) => {
                if(response){
                    this.props.dispatch(this.props.action(response))
                } else{
                    this.props.dispatch(this.props.action({data: [], pages: [], currentPage: 0}))
                }
            })
        }else{
            let dataToSend={
                "scenario_group_prefix_name": this.props.filterValue
            }
            console.log(dataToSend)
            this.props.getApiInfo(page,dataToSend).then((response) => {
                if(response){
                    this.props.dispatch(this.props.action(response))
                } else{
                    this.props.dispatch(this.props.action({data: [], pages: [], currentPage: 0}))
                }
            })
        }

    }
    dotHandleData(e) {
        let index = e.target.id - 1
        let page = this.props.pages[index] + 1
        console.log(page)
        if(window.location.pathname.includes('/view_scenario_catalogue') === true){
            const queryValue = this.props.property.match.params.queryValue !== undefined ? this.props.property.match.params.queryValue : null
            this.props.getApiInfo(page, queryValue).then((response) => {
                if(response){
                    this.props.dispatch(this.props.action(response))
                } else{
                    this.props.dispatch(this.props.action({data: [], pages: [], currentPage: 0}))
                }
            })
        }else{
            let dataToSend={
                "scenario_group_prefix_name": this.props.filterValue
            }
            console.log(dataToSend)
            this.props.getApiInfo(page,dataToSend).then((response) => {
                if(response){
                    this.props.dispatch(this.props.action(response))
                } else{
                    this.props.dispatch(this.props.action({data: [], pages: [], currentPage: 0}))
                }
            })
        }


    }

    render() {
        return(
            <nav>
              <ul className="pagination justify-content-center">
                <li className="page-item">
                  <button
                    className="page-link"
                    aria-label="Previous"
                    onClick={ (e)=> {this.handlePreviousPage(e)} }
                    style={{ color: "#757AF7"}}>
                    <span aria-hidden="true">&laquo;</span>
                  </button>
                </li>
                {this.props.pages.length > 0 ?
                this.props.pages.map( (item,index)=>  {
                    console.log(this.props.pages, "pages")
                    if(item === this.props.currentPage){
                        return (<li className="page-item active" value={item} key={item}>
                                    <button
                                        className="page-link"
                                        id={item}
                                        onClick={ (e)=> {this.handleData(e)} }
                                        style={{color: "white", cursor: "pointer", backgroundColor: "#757AF7"}}
                                    >{item}</button>
                                </li>)
                    } else if(item === null){
                        console.log(index,'........item')
                        return(<li className="page-item" value={index + 1}>
                                    <button
                                        className="page-link"
                                        id= {index}
                                        onClick={ (e)=> {this.dotHandleData(e)} }
                                        style={{color: "black", cursor: "pointer"}}
                                    >...</button>
                                </li>)
                    }else{
                        return (<li className="page-item" value={item} key={item}>
                                    <button
                                        className="page-link"
                                        id={item}
                                        onClick={ (e)=> {this.handleData(e)} }
                                        style={{color: "#757AF7", cursor: "pointer"}}
                                    >{item}</button>
                                </li>)
                    }
                }) : <li className="page-item"><button className="page-link" >0</button></li>}
                <li className="page-item">
                  <button
                    className="page-link"
                    aria-label="Next"
                    onClick={ (e)=> {this.handleForwardPage(e)} }
                    style={{ color: "#757AF7"}}>
                    <span aria-hidden="true">&raquo;</span>
                  </button>
                </li>
              </ul>
            </nav>
        )
    }
}
Pagination.propTypes={
property:PropTypes.array,
getApiInfo:PropTypes.func,
dispatch:PropTypes.func,
action:PropTypes.func,
pages:PropTypes.array,
currentPage:PropTypes.number,
filterValue:PropTypes.string,
//editSelectedRow:PropTypes.string,
//navigateHome:PropTypes.string,
}
Pagination.defaultProps= {
property:[],
pages:[],
currentPage:0,
filterValue:"",
//editSelectedRow:[],
//navigateHome:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default connect()(Pagination);
